import { CardWithC2CssProps } from './CssConfig';

export const rejectionConfigs = [
  {
    componentReference: 'title',
    label: 'Rejections',
    id: 'rejections-holder',
    cssProps: {
      width: '100%',
      display: 'block',
    },
  },

  // cards
  {
    componentReference: 'container',
    id: 'pipelines-cards-container',
    children: [
      {
        containerType: 'rejections',
        componentType: 'card',
        componentReference: 'card',
        id: 'rejections_rejected_candidate',
        selected: false,
        cssProps: CardWithC2CssProps,
        ui: {
          renderType: 'card',
          header: 'applied',
          id: 'applied',
          value: 522,
          topLabel: 'Rejected candidates',
          bottomLabel: 'CANDIDATES',
        },
        api: {
          subject_type: 'rejections',
          metadata: {
            tileKey: 'rejections_rejected_candidate',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'rejections',
            id: 'rejections_rejected_candidate',
          },
        },
      },
      {
        containerType: 'rejections',
        componentType: 'card',
        componentReference: 'card',
        id: 'rejections_time_to_reject',
        selected: false,
        cssProps: CardWithC2CssProps,
        ui: {
          renderType: 'card',
          header: 'interviewed',
          id: 'interviewed',
          value: '10 Days',
          topLabel: 'Time to reject',
          bottomLabel: 'TIME',
        },
        api: {
          subject_type: 'rejections',
          metadata: {
            tileKey: 'rejections_time_to_reject',
            componentType: 'card',
            apiParam: 'card',
            unit: 'time',
            // headerKey: 'time_to_reject',
            id: 'rejections_time_to_reject',
            calculationType: 'avgChange',
            metricKeys: {
              numerator: 'time_to_reject',
              denominator: 'rejections',
            },
          },
        },
      },
    ],
  },
  //trend chart
  {
    containerType: 'rejections',
    componentType: 'chart',
    componentReference: 'chart',
    id: 'rejections_trend_chart',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Rejected trend',
      id: 'rejections_trend_chart',
      chartData: {
        categories: ['2023-Q4', '2024-Q1', '2024-Q2', '2024-Q3', '2024-Q4'],
        series: [0, 0, 23, 357, 165],
      },
      chartType: 'area',
    },
    api: {
      subject_type: 'rejections',
      metadata: {
        tileKey: 'rejections_trend_chart',
        componentType: 'chart',
        apiParam: 'chart_table',
        headerKeys: [],
        id: 'rejections_trend_chart',
      },
    },
  },

  //rejection chart 1 & Chart 2
  {
    componentReference: 'container',
    id: 'rejections-chart-container1',
    children: [
      {
        containerType: 'rejections',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'we_rejected_them',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Rejected reasons (We rejected them)',
          id: 'we_rejected_them',
          chartData: {
            series: [
              {
                name: 'Others (add notes below)',
                y: 3,
              },
              {
                name: 'No rejection reason',
                y: 258,
              },
            ],
          },
          chartType: 'pie',
        },
        api: {
          subject_type: 'rejections',
          metadata: {
            tileKey: 'we_rejected_them',
            componentType: 'chart',
            apiParam: 'chart_table',
            defaultFilters: {
              group_by_1: 'rejection_type',
              group_by_2: 'rejection_reason',
            },
            headerKeys: [],
            id: 'we_rejected_them',
          },
        },
      },
      {
        containerType: 'rejections',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'they_rejected_us',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Rejected reasons (They rejected us)',
          id: 'they_rejected_us',
          chartData: {
            series: [
              {
                name: 'Lacking Skills/Qualifications',
                y: 101,
              },
              {
                name: 'new reason',
                y: 7,
              },
              {
                name: 'Not a culture fit',
                y: 44,
              },
              {
                name: 'Roles',
                y: 3,
              },
              {
                name: 'Compensation',
                y: 1,
              },
            ],
          },
          chartType: 'pie',
        },
        api: {
          subject_type: 'rejections',
          metadata: {
            tileKey: 'they_rejected_us',
            componentType: 'chart',
            apiParam: 'chart_table',
            defaultFilters: {
              group_by_1: 'rejection_type',
              group_by_2: 'rejection_reason',
            },
            headerKeys: [],
            id: 'they_rejected_us',
          },
        },
      },
    ],
  },
  {
    componentReference: 'container',
    id: 'rejections-chart-container1',
    children: [
      {
        containerType: 'rejections',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'they_rejected_us',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Rejected reasons (Others)',
          id: 'others',
          chartData: {
            series: [
              {
                name: 'Lacking Skills/Qualifications',
                y: 101,
              },
              {
                name: 'new reason',
                y: 7,
              },
              {
                name: 'Not a culture fit',
                y: 44,
              },
              {
                name: 'Roles',
                y: 3,
              },
              {
                name: 'Compensation',
                y: 1,
              },
            ],
          },
          chartType: 'pie',
        },
        api: {
          subject_type: 'rejections',
          metadata: {
            tileKey: 'others',
            componentType: 'chart',
            apiParam: 'chart_table',
            defaultFilters: {
              group_by_1: 'rejection_type',
              group_by_2: 'rejection_reason',
            },
            headerKeys: [],
            id: 'others',
          },
        },
      },
    ],
  },

  //visual chart 1 & Chart 2
  {
    componentReference: 'container',
    id: 'rejections-chart-container2',
    children: [
      {
        containerType: 'rejections',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'rejection_by_stage',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Rejection by stage ',
          id: 'rejection_by_stage',
          chartData: {
            categories: ['Applied', 'Interview', 'Offer', 'Lead', 'Unknown'],
            series: [352, 131, 8, 29, 25],
          },
          chartType: 'bar',
        },
        api: {
          subject_type: 'rejections',
          metadata: {
            tileKey: 'rejection_by_stage',
            componentType: 'chart',
            apiParam: 'visual',
            defaultFilters: {
              group_by_1: 'rejected_milestone',
            },
            headerKeys: [],
            id: 'rejection_by_stage',
          },
        },
      },
      {
        containerType: 'rejections',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'rejection_by_source',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Rejection by source (on application)',
          id: 'rejection_by_source',
          chartData: {
            categories: [
              'No source',
              'Kula Career Portal',
              'Internal Job Board',
              'Employee Referral',
              'MNR',
              'Cygnus',
              'Divyanshu',
              'Website',
              'Ankit Nandwani',
              'Aarsh Dayal',
              'Peepal',
              'Internal',
              'Sarthak',
              'Linkedin',
              'Naven',
              'Purnanak',
            ],
            series: [234, 88, 4, 3, 74, 106, 1, 5, 8, 1, 7, 3, 1, 1, 6, 3],
          },
          chartType: 'bar',
        },
        api: {
          subject_type: 'rejections',
          metadata: {
            tileKey: 'rejection_by_source',
            componentType: 'chart',
            apiParam: 'visual',
            defaultFilters: {
              group_by_1: 'appl_contact_source',
            },
            headerKeys: [],
            id: 'rejection_by_source',
          },
        },
      },
    ],
  },

  // table
  {
    containerType: 'rejections',
    componentType: 'table',
    componentReference: 'table',
    id: 'rejections_table',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Rejection breakdown',
      id: 'rejections_table',
      tableData: [
        {
          ds: '0',
          dt: '2023-Q4',
          header: '2023-Q4',
          g1: null,
          g2: null,
          rejections: 0,
          time_to_reject: 0,
          rejections_total: 532,
          rejections_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q1',
          header: '2024-Q1',
          g1: null,
          g2: null,
          rejections: 0,
          time_to_reject: 0,
          rejections_total: 532,
          rejections_per: 0,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q2',
          header: '2024-Q2',
          g1: null,
          g2: null,
          rejections: 23,
          time_to_reject: 2127845,
          rejections_total: 532,
          rejections_per: '4.3',
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q3',
          header: '2024-Q3',
          g1: null,
          g2: null,
          rejections: 357,
          time_to_reject: 371616397,
          rejections_total: 532,
          rejections_per: '67.1',
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q4',
          header: '2024-Q4',
          g1: null,
          g2: null,
          rejections: 152,
          time_to_reject: 85402484,
          rejections_total: 532,
          rejections_per: '28.6',
          subRows: [],
        },
      ],
    },
    api: {
      subject_type: 'rejections',
      metadata: {
        tileKey: 'rejections_table',
        componentType: 'table',
        apiParam: 'chart_table',
        filters: {
          group_by_1: { id: null, label: 'Time', key: 'dt' },
          group_by_2: { id: null, label: 'None' },
        },
        headerKeys: [
          'rejections_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        id: 'rejections_table',
      },
    },
  },
];

export const rejectionsLayoutConfig = [
  {
    key: 'rejections_rejected_candidate',
    x: 0,
    y: 0,
    w: 4,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'rejections_time_to_reject',
    x: 4,
    y: 0,
    w: 4,
    h: 7,
    minW: 3,
    minH: 7,
    maxW: 4,
    maxH: 13,
  },
  {
    key: 'rejections_trend_chart',
    x: 0,
    y: 7,
    w: 12,
    h: 21,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'we_rejected_them',
    x: 0,
    y: 28,
    w: 6,
    h: 23,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'they_rejected_us',
    x: 6,
    y: 28,
    w: 6,
    h: 23,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'rejection_by_stage',
    x: 0,
    y: 51,
    w: 6,
    h: 23,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'rejection_by_source',
    x: 6,
    y: 51,
    w: 6,
    h: 23,
    minW: 3,
    minH: 21,
    maxW: 12,
    maxH: 32,
  },
  {
    key: 'rejections_table',
    x: 0,
    y: 74,
    w: 12,
    h: 18,
    minW: 8,
    minH: 8,
    maxW: 12,
    maxH: 100,
  },
];
